import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./utils/sentry";

// Initialize Sentry before rendering the app
// This ensures all errors are captured from the start
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
